import { Reducer } from 'redux';
import { Actions } from '../../actions/Actions';
import { GPSPartner } from '../Models/GPSPartner';
import { GPSManageListModel } from '../Models/GPSManageListModel';
import { GPSControlInfo } from '../Models/GPSControlInfo';


// TODO: old state should be replacted with AuthenticationStatusState and action should be replaced with AuthenticationAction
export const gpsManageListReducer: Reducer<GPSManageListModel> =
    (oldState: GPSManageListModel = initialGPSManageListState , action: any): GPSManageListModel => {
        let newState: GPSManageListModel;
        switch (action.type) {
            case Actions.GET_ACTION_GPSLIST_DATA:
                newState = { ...oldState };
                break;
            case Actions.SET_ACTION_GPSLIST_DATA:
                newState = action.payload;
                break;
            default:
                newState = oldState;
                break;
        }
        return newState;
    };

    export const initialGPSManageListState: GPSManageListModel = {
        initPartnerList:[],
        initControlList: [],
        initTaskList: [],
        GPS_Partners:[],
        GPS_Controls:[],
        GPS_Task:[],
        isSave:false,
        isCaseDetails:false,
        isBusiness:false,
        isPIRDetails:false,
        isBasicDetails:false,
        isMultiPartner:false,
        isCelaDetails:false,
        isCompliance:false,
        isOperational:false,
        isFinancial:false,
        isCorpDetails:false,
        isOngoing:false,
        isPolicy:false,
        isDocument:false,
        stage:'',
        isPIRManager:false,
        isTask:false,
        isDifferencePartner:false,
        isDifferenceControl:false,
        isDifferenceTasks:false,
    }


export const getGPSListData = (dispatch: any) => {
    dispatch({
        type: Actions.GET_ACTION_GPSLIST_DATA
    });
};

export const setGPSListData = (payload: GPSManageListModel) => (dispatch: any) => {
    dispatch({
        type: Actions.SET_ACTION_GPSLIST_DATA,
        payload
    });
};
